export const userValuation = `
  // store visitorValue in localStorage
  let visitorValue = localStorage.getItem("visitorValue") || 0;

  // on page load, read localStorage vars and push to matomo
  _mtm.push({ visitorValue: localStorage.getItem("visitorValue") || 0 });
  _mtm.push({
    visitorIsValuable: localStorage.getItem("visitorIsValuable") || 0,
  });

  // push value to matomo and localStorage
  function pushValue(val) {
    const currentValue = localStorage.getItem("visitorValue") || 0;

    let newValue = parseInt(currentValue) + parseInt(val);

    _mtm.push({ visitorValue: newValue });
    localStorage.setItem("visitorValue", newValue);

    if (newValue > 50) {
      _mtm.push({ visitorIsValuable: 1 });
      localStorage.setItem("visitorIsValuable", 1);
    }
  }

  // the triggers
  const tabsSelector = '[class*="Tabs_list"] button';
  document.addEventListener("click", function (e) {
    if (e.target.matches(tabsSelector)) {
      _mtm.push({ event: "tab-click" });
      pushValue(10);
    }
  });
`;
